import React, { useState, useEffect, useRef } from "react";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { imagesData } from "../media";

const PrintPage = () => {
  const [visibleCount, setVisibleCount] = useState(12);
  const galleryRef = useRef(null);

  const printCategories = [
    "cards",
    "stickers",
    "boxes",
    "notes",
    "special",
    "folders",
  ];
  const printImages = imagesData.filter((image) =>
    printCategories.includes(image.filter)
  );

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 800
      ) {
        setVisibleCount((prevCount) => {
          if (prevCount < printImages.length) {
            return prevCount + 6;
          }
          return prevCount;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [printImages.length]);

  useEffect(() => {
    if (!galleryRef.current) return;
    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryRef.current,
      children: 'a',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 0.9,
      padding: { top: 20, bottom: 20, left: 20, right: 20 },
    });
    lightbox.init();
    return () => lightbox.destroy();
  }, [visibleCount]);

  return (
    <div
      className="pt-48 md:pt-56 pb-20 specialBg min-h-screen text-mainColor"
      dir="rtl"
    >
      <div className="max-w-[1200px] mx-auto px-4">
        <div className="text-center mb-16">
          <h1
            data-aos="fade-down"
            className="font-bold text-4xl md:text-5xl lg:text-6xl gold-text mb-6"
          >
            דפוס דיגיטלי
          </h1>
          <h2
            data-aos="fade-up"
            className="text-xl md:text-2xl lg:text-3xl text-white font-medium max-w-[800px] mx-auto leading-relaxed"
          >
            דפוס דיגיטלי מתקדם לכל סוגי העבודות
            <br />
            איכות גבוהה, שירות מהיר ותוצאות מדויקות: מדבקות בגלילים, מארזי קלפים וקלפים, אריזות למוצרים לפי דרישה, פולדרים, מחברות ממותגות, פליירים, חוברות וספרים, כרטיסי ביקור, מגנטים, ניירת משרדית ועוד מגוון רחב של עבודות דפוס.
          </h2>
        </div>

        <div ref={galleryRef} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          {printImages.slice(0, visibleCount).map((image, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={(index % 4) * 100}
              className="relative group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-orange-600/20 transition-all duration-500 aspect-square"
            >
              <a href={image.src} data-pswp-width="2000" data-pswp-height="2000" target="_blank" rel="noreferrer">
                <img
                  src={image.src}
                  alt={`עבודת דפוס ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out cursor-pointer"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </a>
            </div>
          ))}
        </div>

        {printImages.length === 0 && (
          <div className="text-center text-2xl text-secondaryColor mt-10">
            בקרוב יעלו עבודות נוספות...
          </div>
        )}
      </div>
    </div>
  );
};

export default PrintPage;
